import { useTranslation } from 'react-i18next'
import { Skeleton, StayHeader } from '@/ds'
import { useLoadedStay } from '../../stay/StayProvider'

interface Props {
  /** Pestaña (v2.ds.nav.*) o pantalla de flujo (v2.comun.pantallas.*) aún no migrada */
  titleKey: 'estancia' | 'reserva' | 'accesos' | 'guia' | 'ayuda' | 'checkin' | 'salida'
}

/** Pestaña aún no migrada: título del sistema y esqueletos (nunca spinner). Los bloques B1–B7 la sustituyen. */
export function TabPlaceholder({ titleKey }: Props) {
  const { t, i18n } = useTranslation()
  const stay = useLoadedStay()
  const fmt = new Intl.DateTimeFormat(i18n.language, { weekday: 'short', day: 'numeric', month: 'short' })
  const dates = `${stay.unit.name} · ${fmt.format(new Date(stay.dates.checkIn))} – ${fmt.format(new Date(stay.dates.checkOut))}`
  return (
    <main className={titleKey === 'estancia' ? 'page page--wide' : 'page'}>
      {titleKey === 'estancia' ? (
        <StayHeader propertyName={stay.property.name} subtitle={dates} image={stay.property.coverImageUrl ?? stay.unit.photos[0]} />
      ) : (
        <h1>{titleKey === 'checkin' || titleKey === 'salida' ? t(`v2.comun.pantallas.${titleKey}`) : t(`v2.ds.nav.${titleKey}`)}</h1>
      )}
      <Skeleton height={64} />
      <Skeleton height={64} />
      <Skeleton height={120} />
    </main>
  )
}
